export const BLOCK_DAYS_AMOUNT = 14;
